import { createRoute } from '@tanstack/react-router'

import { drugSearchRoute } from 'src/pages/drugSearch/router'

export const route = createRoute({
  getParentRoute: () => drugSearchRoute,
  path: 'configuration',
})
